<template>
  <button class="btn btn-default" :class="rootClasses" :disabled="isDisabled">
    <span v-if="!loading">
      <slot />
    </span>
    <span v-if="loading" class="flex justify-center items-center text-white">
      <svg class="w-32 h-8" viewBox="0 0 100 60">
        <rect x="0" y="0" width="10" height="60" rx="6">
          <animate
            attributeType="CSS"
            attributeName="height"
            values="60;20;60;"
            begin="0s"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeType="CSS"
            attributeName="y"
            begin="0s"
            values="0;20;0;"
            dur="1s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="20" y="0" width="10" height="60" rx="6">
          <animate
            attributeType="CSS"
            attributeName="height"
            values="60;20;60"
            begin="0.2s"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeType="CSS"
            attributeName="y"
            values="0;20;0"
            begin="0.2s"
            dur="1s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="40" y="0" width="10" height="60" rx="6">
          <animate
            attributeType="CSS"
            attributeName="height"
            values="60;20;60"
            begin="0.4s"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeType="CSS"
            attributeName="y"
            values="0;20;0"
            begin="0.4s"
            dur="1s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="60" y="0" width="10" height="60" rx="6">
          <animate
            attributeType="CSS"
            attributeName="height"
            values="60;20;60"
            begin="0.6s"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeType="CSS"
            attributeName="y"
            values="0;20;0"
            begin="0.6s"
            dur="1s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="80" y="0" width="10" height="60" rx="6">
          <animate
            attributeType="CSS"
            attributeName="height"
            values="60;20;60"
            begin="0.8s"
            dur="1s"
            repeatCount="indefinite"
          />
          <animate
            attributeType="CSS"
            attributeName="y"
            values="0;20;0"
            begin="0.8s"
            dur="1s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>
    </span>
  </button>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  type PropType,
  type ButtonHTMLAttributes,
} from "vue";
import { useIsFormDirty, useIsFormValid } from "vee-validate";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Button",
  props: {
    btnClass: {
      type: String,
      default: "btn-default",
    },
    loading: Boolean,
    disableFalse: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: String as PropType<ButtonHTMLAttributes>,
      default: "submit",
    },
  },

  setup(props, { slots }) {
    const isDirty = useIsFormDirty();
    const isValid = useIsFormValid();

    const isDisabled = computed(() => {
      // Block clicks/submit while an async action is in flight. Prevents
      // double-submits (e.g. a second click cancelling an in-flight file
      // upload, surfacing as a status_code 0 network error in Sentry).
      if (props.loading) {
        return true;
      }
      if (props.disableFalse) {
        return false;
      }
      return !isDirty.value || !isValid.value;
    });
    const rootClasses = computed(() => [
      {
        "btn-default-loading": props.loading,
      },
    ]);
    return { rootClasses, isDisabled };
  },
});
</script>

<style scoped>
rect {
  fill: #fff;
}
</style>
